<template>
    <modal
        ref="modal"
        class="modal-background changelog-latest-modal"
        body-class="h-auto"
        @modal-close="onClose"
    >
        <template v-slot:header>
            Zmiany w systemie Dostartu
        </template>
        <template v-slot:body>
            <changelog-entry-item
                v-if="entry"
                :entry="entry"
                variant="light"
                is-first
                is-last
            />
        </template>
        <template v-slot:footer>
            <base-button
                btn2
                short
                @click="goToList"
            >
                Zobacz pełną listę zmian
            </base-button>
            <base-button
                btn1
                short
                @click="close"
            >
                ZAMKNIJ
            </base-button>
        </template>
    </modal>
</template>

<script>
import Modal from '@/components/Modal';
import ChangelogEntryItem from '@/components/ChangelogEntryItem';
import { markSeen } from '@/utils/changelogStorage';

export default {
    name: 'ChangelogLatestModal',
    components: {
        Modal,
        ChangelogEntryItem,
    },
    props: {
        entry: {
            type: Object,
            default: null,
        },
    },
    methods: {
        open() {
            if (this.$refs.modal) {
                this.$refs.modal.openModal();
            }
        },
        close() {
            if (this.$refs.modal && this.$refs.modal.show) {
                this.$refs.modal.closeModal();
            }
        },
        onClose() {
            if (this.entry && this.entry.id != null) {
                markSeen(this.entry.id);
            }
        },
        goToList() {
            this.close();
            this.$router.push({
                name: 'panel-changelog',
                alias: true,
            });
        },
    },
};
</script>

<style scoped>
.changelog-latest-modal >>> .modal__header {
    background-color: var(--color-slate);
}

.changelog-latest-modal >>> .modal__body {
    padding: 16px;
    background: var(--color-pale-grey);
}

.changelog-latest-modal >>> .modal__footer {
    background: var(--color-pale-grey);
}

@media (max-width: 991px) {
    .changelog-latest-modal >>> .modal__dialog {
        background-color: var(--color-pale-grey);
    }

    .changelog-latest-modal >>> .modal__footer {
        flex-direction: column;
        gap: 8px;
        padding: 16px;
    }

    .changelog-latest-modal >>> .modal__footer:before {
        left: 16px;
        width: calc(100% - 32px);
    }

    .changelog-latest-modal >>> .modal__footer .btn {
        width: 100%;
    }
}
</style>
